import { DiscountContext } from '@/lib/hooks/useSiteWideDiscount';
import { useSiteWideDiscounts } from '@/lib/siteWideDiscounts';
import React from 'react';

export const DiscountProvider = ({ children }: { children: React.ReactNode }) => {
  const { siteWideCoupons, subCancelledEntreesDiscount, treatsDiscount, isLoading } =
    useSiteWideDiscounts();

  return (
    <DiscountContext.Provider
      value={{
        siteWideCoupons,
        subCancelledEntreesDiscount,
        treatsDiscount,
        loading: isLoading
      }}
    >
      {children}
    </DiscountContext.Provider>
  );
};
